import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import * as React from 'react';

import { Providers } from '@/components/providers';

import type { QueryClient } from '@tanstack/react-query';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent(): React.ReactElement {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
